import { BaseModel } from '../email-template/base-model.interface';
import BlockModel from '../email-template/block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface MetaSingleImageUrlModel extends BaseModel {
  variables?: { [key: string]: string } | MetaSingleImageUrlVariables;
}

export interface MetaSingleImageUrlVariables {
  Link: string;
}

export class MetaSingleImageUrlInitVariables implements MetaSingleImageUrlVariables {
  Link = '';
}

export class MetaSingleImageUrlInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new MetaSingleImageUrlInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}